<template>
  <TosListVuetify :entityName="entityName" :headers="headers" :validateFunction="validate" >
    <template #customFilters="slotProps">
      <v-container fluid>
        <v-row>
          <v-col cols="3">
            <v-autocomplete  :label="tLabel('Tipo Sigillo')" v-model.number="slotProps.data.tipoSigillo___EQ"  :items="tipoSigillo" clearable />
          </v-col>
          <v-col cols="3">
            <v-text-field label="Codice Sigillo" v-model="slotProps.data.codSigillo" />
          </v-col>
          <v-col cols="3">
            <v-text-field label="Descrizione Sigillo" v-model="slotProps.data.descCodSigillo" />
          </v-col>
        </v-row>
      </v-container>
    </template>

    <template #editF="slotProps">
      <div v-if="slotProps.data" class="p-cardialog-content">
        <v-row>
            <v-col cols="4">
              <v-autocomplete  :label="tLabel('Tipo Sigillo') + '*'" v-model="slotProps.data.tipoSigillo"  :items="tipoSigillo" :rules="[rules.required]" :error-messages="slotProps.errors.tipoSigillo" clearable/>
            </v-col>
            <v-col cols="4">
              <v-text-field  :label="tLabel('Codice Sigillo') + '*'" v-model="slotProps.data.codSigillo" :rules="[rules.required]" :error-messages="slotProps.errors.codSigillo"/>
            </v-col>
            <v-col cols="4">
              <v-text-field  :label="tLabel('Descrizione Sigillo') + '*'" v-model="slotProps.data.descCodSigillo" :rules="[rules.required]" :error-messages="slotProps.errors.descCodSigillo" />
            </v-col>
        </v-row>      
      </div>
    </template>
  </TosListVuetify>
</template>

<script>
import TosListVuetify from "../../components/anagrafiche/TosListVuetify";
import FormatsMixins from "../../mixins/FormatsMixins";

export default {
  name: "Sigilli",
  data() {
    return {
      entityName: "tipiSigillo",
      tipoSigillo: ["UTI","CARRO"],
      headers: [
        { text: "", value: "action" },
        { text: "Tipo Sigillo", value: "tipoSigillo"},
        { text: "Codice Sigillo", value: "codSigillo"},
        { text: "Descrizione Sigillo", value: "descCodSigillo" },
      ],
    };
  },
  components: {
    TosListVuetify: TosListVuetify
  },
  mixins: [FormatsMixins],
  methods: {
    validate(item) {
       let errors = {};
       // TODO
       return errors;
    }
  },
};
</script>
